<template>
  <div class="vh-100 d-flex justify-content-center">
    <div class="form-access my-auto">
      <form autocomplete="off">
        <span>Create Demo Account</span>
        <div class="form-group">
          <input type="text" name="demo-account-name" autocomplete="off" class="form-control" :class="{ 'red-border': 0 === name.length, 'green-border': 0 !== name.length }" placeholder="Name" v-model="name" required />
        </div>
        <div class="form-group">
          <input type="email" name="demo-account-email" autocomplete="off" class="form-control" :class="{ 'red-border': !isValidEmail, 'green-border': isValidEmail }" placeholder="Email" v-model="email" required />
        </div>
        <div class="form-group">
          <input type="tel" name="demo-account-phone" autocomplete="off" class="form-control" :class="{ 'red-border': 0 === phone.length, 'green-border': 0 !== phone.length }" placeholder="Phone" v-model="phone" required />
        </div>
        <div class="form-group">
          <input type="password" name="demo-account-password" autocomplete="new-password" class="form-control" :class="{ 'red-border': 0 === password.length, 'green-border': 0 !== password.length }" placeholder="Password" v-model="password" required />
        </div>
        <button type="submit" class="btn btn-primary" :disabled="!submitEnabled" @click.prevent="registerUser()">Create
          Account</button>
      </form>
      <h2>
        <router-link :to="{ name: 'Login', query: { accountType: 'demo' } }">{{ t("loginLabel") }}</router-link>
      </h2>
    </div>
  </div>
</template>

<script>
import http from "@/api/http-common";
import HttpUtils from "@/assets/js/http_utils.js";
import I18n from "@/lang/i18n.js";

function validateEmail(mail) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail.trim());
}

export default {
  data() {
    return {
      name: "", email: "", phone: "", password: "", confirmedPasswordClass: "black-color"
    }
  },
  methods: {
    t(key, ...args) {
      return I18n.t(key, "EN", ...args);
    },
    async registerUser() {
      if (!this.submitEnabled) {
        return;
      }

      try {
        // always demo
        const res = await http.getApiClient(0).get("", {
          params: {
            a: "demo_reg_ex",
            em: encodeURIComponent(this.email),
            ph: encodeURIComponent(this.phone),
            name: encodeURIComponent(this.name),
            pw: encodeURIComponent(this.password)
          }});
        if (res) {
          // check answer
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, "EN");          
          if (errorCode === "") {
            this.$toast.success("You have registered with EFOCS. Please follow the link in your email to activate your account", {
              "duration": 10000,
              "pauseOnHover": true
            });
            this.$router.push({ name: "Login" });
          } else {
            this.$toast.error(errorCode, {
              "duration": 5000,
              "pauseOnHover": true
            });
          }
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
  computed: {
    isValidEmail() {
      return validateEmail(this.email);
    },
    submitEnabled() {
      return 0 < this.name.length && 0 < this.password.length &&
        this.isValidEmail && 0 < this.phone.length;
    }
  }
}
</script>

<style scoped>


input.red-border {
  border: 2px solid red;
}

input.green-border {
  border: 2px solid green;
}

input.black-border {
  border: 2px solid black;
}
</style>
